var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightingOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    height: 14,
    width: 14,
    id: "Flash-Off--Streamline-Flex.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Flash Off Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flash-off--flash-power-connect-charge-off-electricity-lightning"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 383",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.4083 3.9964C5.7542 2.568 7.2798 1.4584 8.824 0.894L8.5575 4.7611C9.4485 4.7941 10.3968 4.8671 11.2052 5.0076C11.7628 5.1045 12.0401 5.6869 11.7486 6.1719C11.279 6.9528 10.5307 7.9386 9.5312 9.0203",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 384",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.624 6.2288C2.5027 6.4113 2.3859 6.5952 2.2741 6.7801C1.898 7.4021 2.3725 8.1514 3.0993 8.1514H5.2483C4.8344 9.8604 4.6723 11.5234 4.5953 13.3609C5.5575 12.6648 6.4407 11.9533 7.2386 11.2505",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.975 0.6391C5.0093 5.759 7.8053 8.5308 13.025 12.6918",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightingOff);
export default __webpack_public_path__ + "static/media/lighting-off.be9028239f07eb96bc3873ff3d003eba.svg";
export { ForwardRef as ReactComponent };